import UserFollowButtonComponent from './components/UserFollowButton'
import BoardFollowButtonComponent from './components/BoardFollowButton'
import './FollowButton.scss'

export const UserFollowButton = UserFollowButtonComponent
export const BoardFollowButton = BoardFollowButtonComponent
